/**
 * MEETING BOOKING LINK.
 * Destination of the shared link (unwrapped from LinkedIn's safety redirect, without its tracking parameters).
 * Change this one value to point every booking button elsewhere.
 */
export const BOOKING_URL = 'https://shorturl.at/et0N2';
export const isBookingConfigured = /^https?:\/\//.test(BOOKING_URL);

/** Public link copied by "Share with a colleague". */
export const SHARE_URL = 'https://poteligeo.snakker.io';

export const clients = ['Roche', 'GSK', 'CSL', 'Novartis', 'LEO Pharma'];

export const sender = { name: 'Morten Hjelmsoe', role: 'Founder & CEO · Snakker™' };

export const conceptSections = [
  {
    label: 'The challenge',
    body: 'Physicians familiar with an established medicine may already have formed opinions and treatment habits.',
  },
  {
    label: 'The opportunity',
    body: 'Meaningful new clinical evidence creates a fresh reason to revisit those perceptions and evaluate what the findings could mean for patients.',
  },
  {
    label: 'The idea',
    body: 'Use a short, interactive scientific Snak to make complex study findings more accessible, memorable and clinically relevant.',
  },
];

export const conceptAmbition = {
  label: 'The ambition',
  lead: 'Not another product presentation.',
  emphasis: 'A reason to reconsider.',
};

export const opportunities = [
  { title: 'What if it’s not eczema?', detail: 'Earlier CTCL recognition.' },
  { title: 'When disease goes beyond the skin', detail: 'Understanding blood involvement.' },
  { title: 'The right patient. The right moment.', detail: 'Patient selection and sequencing.' },
  { title: 'Progression or treatment-related rash?', detail: 'Treatment-management confidence.' },
  { title: 'From trial to real world', detail: 'Connecting clinical and real-world evidence.' },
];

export const opportunitiesClosing =
  'The right approach depends on Kyowa Kirin’s priorities — something we’d welcome the opportunity to explore together.';
